var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Linear / Messages, Conversation / Pen 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.33398 18.332H16.6673",
    stroke: "#1552E8",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.574 3.05374L12.1919 2.43582C13.2158 1.41202 14.8757 1.41202 15.8995 2.43582C16.9233 3.45962 16.9233 5.11954 15.8995 6.14334L15.2815 6.76126M11.574 3.05374C11.574 3.05374 11.6513 4.36682 12.8099 5.52542C13.9685 6.68402 15.2815 6.76126 15.2815 6.76126M11.574 3.05374L5.8932 8.73457C5.50843 9.11934 5.31604 9.31173 5.15058 9.52386C4.95541 9.77409 4.78807 10.0448 4.65155 10.3313C4.53581 10.5742 4.44977 10.8323 4.27769 11.3485L3.54852 13.536M15.2815 6.76126L9.60072 12.4421C9.21594 12.8269 9.02356 13.0192 8.81143 13.1847C8.5612 13.3799 8.29045 13.5472 8.00397 13.6837C7.76112 13.7995 7.503 13.8855 6.98677 14.0576L4.79926 14.7868M4.79926 14.7868L4.26455 14.965C4.0105 15.0497 3.73042 14.9836 3.54107 14.7942C3.35172 14.6049 3.2856 14.3248 3.37028 14.0707L3.54852 13.536M4.79926 14.7868L3.54852 13.536",
    stroke: "#1552E8"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/Pen.0372a60ce37b5990da83d692a6e6530f.svg";
export { ForwardRef as ReactComponent };